import { render } from "./SocialsList.vue?vue&type=template&id=5747f41a&scoped=true"
import script from "./SocialsList.vue?vue&type=script&lang=js"
export * from "./SocialsList.vue?vue&type=script&lang=js"

import "./SocialsList.vue?vue&type=style&index=0&id=5747f41a&lang=scss&scoped=true"

import exportComponent from "/home/webdevs/livesite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5747f41a"]])

export default __exports__